/**
 * @description: 艺人台票购买明细报表
 * @update: lyr
*/
<template>
    <div class="wr-ytpgm-report">
        <div class="list" v-show="!showRefundDetail">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ytcTime">
                        <input type="text" class="form-control laydate-icon" v-model="startTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="endTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="payPlatform" data-placeholder="请选择支付类型"></select>
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="group_txt" ref="group_txt" readonly @click="openGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">购票类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ticketType" data-placeholder="请选择购票类型">
                        <option value="0">全部</option>
                        <option value="1">正常台票</option>
                        <option value="2">二次台票</option>
                        <option value="3">迟到台票</option>
                    </select>
                </div>
                <label class="list-label-2">艺人:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="search_word" placeholder="请输入艺名/腰牌">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYtpgmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYtpgmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-6">台票金额小计:</label>
                <div class="list-total" ref="ytpgm_amount"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ytpgmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="export_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="create_time">
                            <label>购买时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="pson_info">
                            <label>艺人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="ticket_name">
                            <label>台票名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="pay_platform_name">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="ticket_type_name">
                            <label>购票类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="amount">
                            <label>台票金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="refund_amount">
                            <label>退款金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="group-panel">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="group_name">
                <img src="../../../assets/images/group_search.png" @click="getGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='group_allcheck' @click='groupCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="groupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="groupSub()">确定</button>
            </div>
        </div>
        <!-- 退款详情 -->
        <div class="refund-detail" v-show="showRefundDetail">
            <h4>退款详情</h4>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" ref="refundList"></table>
            </div>
            <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="showRefundDetail=false">返回</button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                startTime: "",
                endTime: "",
                export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['create_time', 'pson_info', 'group_name', 'ticket_name', 'pay_platform_name', 'ticket_type_name', 'amount', 'refund_amount', 'admin_name'],
                export_type: 1,
                group_txt: '',
                group_allcheck: false,
                c_group_allcheck: false,
                group_checkboxModel: [],
                c_group_checkboxModel: [],
                group_checkboxData: [],
                group_name: '',
                pay_type_list: [],
                search_word: '',
                showRefundDetail: false,
            }
        },
        watch: {
            group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.group_checkboxModel.length >= this.group_checkboxData.length) {
                        this.group_allcheck = true;
                        this.c_group_allcheck = true;
                    } else {
                        this.group_allcheck = false;
                        this.c_group_allcheck = false;
                    }
                },
                deep: true
            },

            export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.endTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.endTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.startTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.endTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ytcTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 支付类型
                                _this.getPayType(e.params.data.id);
                                // 组别
                                _this.group_txt = ''
                                _this.group_checkboxModel = []
                                _this.getGroupData()
                                _this.setShopDefaultTime(e.params.data.id);
                            });

                            $(_this.$refs.ticketType).select2({
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                            $(_this.$refs.shop).val(data.response.result[1].id).trigger('change');
                            _this.getPayType(data.response.result[1].id)
                            _this.setShopDefaultTime(data.response.result[1].id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 获取支付类型
            getPayType: function(shop_id) {
                const _this = this;

                Vue.axios.post('Order/getAllPayPlatform', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "api_type": "pson_ticket"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.pay_type_list = [{
                            id: '0',
                            text: '全部'
                        }];
                        for(let [key, value] of Object.entries(res.data.response.data)) {
                            _this.pay_type_list.push({id: key, text: value});
                        }
                        $(_this.$refs.payPlatform).select2({
                            data: _this.pay_type_list,
                            allowClear: true,
                            minimumResultsForSearch: -1,
                            language: "zh-CN"
                        });
                        $(_this.$refs.payPlatform).val('0').trigger('change');
                        _this.innitYtpgmTable();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },


            // 进入选择组别
            openGroup: function() {
                this.c_group_checkboxModel = this.group_checkboxModel;
                this.group_checkboxModel = [];
                this.getGroupData();
                this.group_checkboxModel = this.c_group_checkboxModel;
                $('.list').hide();
                $('.group-panel').show();
            },
            // 获取组别列表
            getGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.shop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupCheckedAll: function() {
                let _this = this;
                _this.group_allcheck = _this.c_group_allcheck;
                if(!_this.group_allcheck) { // 实现全选
                    _this.group_checkboxModel = [];
                    _this.group_checkboxData.forEach(function(item) {
                        _this.group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.group_checkboxModel = [];
                }
            },
            // 返回
            groupBack: function() {
                $('.group-panel').hide();
                $('.list').show();
                this.group_checkboxModel = this.c_group_checkboxModel;
            },

            groupSub: function() {
                let _this = this;
                let arr = [];
                _this.group_checkboxData.forEach(function(item) {
                    _this.group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.group_txt = arr.join(',');
                $('.group-panel').hide();
                $('.list').show();
            },


            // 表格
            innitYtpgmTable: function() {
                let _this = this;
                $(_this.$refs.ytpgmList).bootstrapTable('destroy');
                $(_this.$refs.ytpgmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYtpgmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "create_time",
                        title: "购买时间",
                        width: "15%"
                    }, {
                        field: "pson_info",
                        title: "艺人",
                        width: "15%"
                    }, {
                        field: "group_name",
                        title: "组别",
                        width: "10%"
                    }, {
                        field: "ticket_name",
                        title: "台票名称",
                        width: "10%"
                    }, {
                        field: "pay_platform_name",
                        title: "支付类型",
                        width: "10%"
                    }, {
                        field: "ticket_type_name",
                        title: "购票类型",
                        width: "10"
                    }, {
                        field: "amount",
                        title: "台票金额",
                        width: "10%"
                    }, {
                        field: "refund_amount",
                        title: "退款金额",
                        width: "10%"
                    },  {
                        field: "admin_name",
                        title: "操作人",
                        width: "10%"
                    }, {
                        field: 'op',
                        title: "操作",
                        width: "10%",
                        events: {
                            'click .detail': function(e, value, row) {
                                var refundList = row.refund_log
                                _this.innitRefundcTable(refundList)
                                _this.showRefundDetail = true
                            }
                        },
                        formatter: function(value, row, index) {
                            if (row.refund_log.length > 0) {
                                return '<span class="text-blue detail">详情</span>'
                            }else {
                                return ''
                            }
                        }
                    }],
                });
            },


            getYtpgmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.startTime,
                            "end_time": _this.endTime,
                            "shop_id": $(_this.$refs.shop).val(),
                            "pay_platform": $(_this.$refs.payPlatform).val(),
                            "group_id": _this.group_checkboxModel,
                            "search_word": _this.search_word,
                            "ticket_type": $(_this.$refs.ticketType).val(),
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PersonnelTicketOrder/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.count,
                                rows: data.response.data.data
                            });
                            $(_this.$refs.ytpgm_amount).text(data.response.data.total_amount);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYtpgmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "PersonnelTicketOrder/orderListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.exportList();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 导出
            exportList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.export_checkModel);
                window.location.href = Vue.ctUrl + "PersonnelTicketOrder/orderListExport?" +
                    "&start_time=" + _this.startTime +
                    "&end_time=" + _this.endTime +
                    "&shop_id=" + $(_this.$refs.shop).val() +
                    "&pay_platform=" + $(_this.$refs.payPlatform).val() +
                    "&group_id=" + _this.group_checkboxModel +
                    "&search_word=" +  _this.search_word +
                    "&ticket_type=" + $(_this.$refs.ticketType).val() +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.export_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },

            // 表格
            innitRefundcTable: function(arr) {
                let _this = this;
                $(_this.$refs.refundList).bootstrapTable('destroy');
                $(_this.$refs.refundList).bootstrapTable({
                    data: arr,
                    columns: [{
                        field: "create_time",
                        title: "退款时间",
                        width: "25%"
                    }, {
                        field: "refund_amount",
                        title: "退款金额",
                        width: "25%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "25%"
                    }, {
                        field: "refund_reason",
                        title: "备注",
                        width: "25%"
                    }]
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .group-panel {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>